import { z } from 'zod';
const nonEmptyStringSchema = z.string().trim().min(1);
const timestampSchema = z.string().trim().min(1);
const nonNegativeIntSchema = z.number().int().min(0);
export const polymarketEventKindSchema = z.enum(['match', 'future', 'player_prop', 'tournament_prop', 'unknown']);
export const polymarketEventTabSchema = z.enum(['all', 'matches', 'plays']);
export const adminPolymarketEventsQuerySchema = z.object({
    tab: polymarketEventTabSchema.optional().default('matches'),
    q: z.string().trim().max(120).optional(),
    page: z.coerce.number().int().positive().optional().default(1),
    pageSize: z.coerce.number().int().positive().max(100).optional().default(25),
});
export const adminPolymarketEventRowSchema = z.object({
    polymarketEventId: nonEmptyStringSchema,
    slug: nonEmptyStringSchema,
    title: nonEmptyStringSchema,
    eventKind: polymarketEventKindSchema,
    homeTeamLabel: nonEmptyStringSchema.nullable(),
    awayTeamLabel: nonEmptyStringSchema.nullable(),
    startTime: timestampSchema.nullable(),
    endTime: timestampSchema.nullable(),
    marketCount: nonNegativeIntSchema,
    outcomeCount: nonNegativeIntSchema,
    moneylineMarketCount: nonNegativeIntSchema,
    firstSeenAt: timestampSchema,
    lastFetchedAt: timestampSchema,
    active: z.boolean(),
    closed: z.boolean(),
    newToday: z.boolean(),
    mappingStatus: z.enum(['reviewed', 'candidate', 'missing']),
    reviewedTargetCount: nonNegativeIntSchema,
    candidateTargetCount: nonNegativeIntSchema,
});
export const adminPolymarketEventsSummarySchema = z.object({
    generatedAt: timestampSchema,
    totalEventCount: nonNegativeIntSchema,
    matchEventCount: nonNegativeIntSchema,
    playEventCount: nonNegativeIntSchema,
    newTodayCount: nonNegativeIntSchema,
    latestIngestRun: z.object({
        ingestRunId: nonEmptyStringSchema,
        tagId: nonEmptyStringSchema,
        status: z.enum(['success', 'failed']),
        startedAt: timestampSchema,
        completedAt: timestampSchema.nullable(),
        requestCount: nonNegativeIntSchema,
        fetchedEventCount: nonNegativeIntSchema,
        keptMatchCount: nonNegativeIntSchema,
        keptPlayCount: nonNegativeIntSchema,
        newEventCount: nonNegativeIntSchema,
        updatedEventCount: nonNegativeIntSchema,
        upsertedMarketCount: nonNegativeIntSchema,
        upsertedOutcomeCount: nonNegativeIntSchema,
        errorMessage: z.string().nullable(),
    }).nullable(),
});
export const adminPolymarketEventsListResponseSchema = z.object({
    summary: adminPolymarketEventsSummarySchema,
    items: z.array(adminPolymarketEventRowSchema),
    pagination: z.object({
        page: z.number().int().positive(),
        pageSize: z.number().int().positive(),
        total: nonNegativeIntSchema,
        totalPages: nonNegativeIntSchema,
    }),
});
export const adminPolymarketEventsRefreshRequestSchema = z.object({
    tagId: z.string().trim().min(1).optional().default('102232'),
    active: z.boolean().optional().default(true),
    closed: z.boolean().optional().default(false),
    limit: z.number().int().positive().max(100).optional().default(100),
    maxPages: z.number().int().positive().max(20).optional().default(10),
});
export const adminPolymarketEventsRefreshResponseSchema = z.object({
    ingestRunId: nonEmptyStringSchema,
    tagId: nonEmptyStringSchema,
    requestCount: nonNegativeIntSchema,
    fetchedEventCount: nonNegativeIntSchema,
    keptMatchCount: nonNegativeIntSchema,
    keptPlayCount: nonNegativeIntSchema,
    newEventCount: nonNegativeIntSchema,
    updatedEventCount: nonNegativeIntSchema,
    upsertedMarketCount: nonNegativeIntSchema,
    upsertedOutcomeCount: nonNegativeIntSchema,
    startedAt: timestampSchema,
    completedAt: timestampSchema,
});
